import Vue from 'vue';

import * as libComponents from '../components/lib';
import * as svgComponents from '../components/svg';

export function useUI () {
    for (const [key, component] of Object.entries({ ...libComponents, ...svgComponents })) {
        Vue.component(key, component);
    }
}
